module.exports = __webpack_public_path__ + "static/img/erp51.3a02d4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/erp51.jpg
// module id = KqbX
// module chunks = 73